<template>
	<div class="container">
		<div class="pc-contact">
			<div class="left">
				<div class="tit en">CONTACT</div>
				<ul class="list">
					<li class="item">
						<label class="label">BRAND</label>
						WEONUS
					</li>
					<li class="item">
						<label class="label">LOCATION</label>
						서울특별시 강남구 도산대로26길 20,1층<br />
						(논현동, NEWTURN빌딩)
					</li>
					<li class="item">
						<label class="label">TEL</label>
						02 - 6956 - 2791
					</li>
					<li class="item">
						<label class="label">FAX</label>
						070 - 4693 - 5728
					</li>
				</ul>

				<div class="tit">문의하기</div>
				<div class="input-wrap">
					<input type="text" class="input-text" placeholder="이메일을 입력해주세요." />
					<input type="text" class="input-text" placeholder="핸드폰 번호를 입력해주세요." />
					<textarea class="input-textarea" placeholder="문의내용을 입력해주세요." rows="6"></textarea>
					<button type="button" class="btn btn-full btn-black">보내기</button>
				</div>
			</div>
			<div class="right">
				<div class="map-wrap" id="map">
					<div class="pin" style="left: 100px; top: 100px"></div>
				</div>
			</div>
		</div>
	</div>
	<div class="footer">
		<div class="footer-wrap">
			<div class="footer-logo"></div>
			<div class="footer-info">
				<div class="line">
					<span>대표 : 서치원</span>
					<span>사업자 등록번호 : 395-87-02794</span>
					<span>주소 : 서울특별시 강남구 도산대로26길 20, 1층(논현동, NEWTURN빌딩)</span>
				</div>
				<div class="line">
					<span>대표번호 : 02-6956-2791</span>
					<span>팩스 : 070-4693-5728</span>
				</div>
			</div>
			<div class="footer-copy">
				개인정보처리방침<br />
				Copyrightⓒ2023 WEONUS All rights reserved.
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PC_Main',
	components: {},
	computed: {},
	data() {
		return { map_1: null, marker_1: null };
	},
	created() {
		this.$loadScript(
			'https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=' +
				process.env.VUE_APP_NAVER_API_ID +
				'&submodules=panorama',
		)
			.then(() => {
				this.loadMap();
			})
			.catch(() => {});
	},
	methods: {
		loadMap() {
			this.map_1 = new window.naver.maps.Map('map', {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 16,
			});
			this.map_1.setCenter({ lat: this.item.pt.y, lng: this.item.pt.x });
			this.map_1.setSize({ width: '550px', height: '500px' });
			this.marker_1 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
				map: this.map_1,
			});
		},
	},
};
</script>
